import { useLanguage } from "../i18n/LanguageContext";
import { Reveal, Overline } from "./Reveal";

// Team members go in content once real names/photos exist:
// { photo: "/assets/team/x.jpg", name: {ar,en}, role: {ar,en}, bio: {ar,en} }
const teamMembers = [];

const TeamSection = () => {
    const { t, lang } = useLanguage();
    const hasMembers = teamMembers.length > 0;
    return (
        <section id="team" className="scroll-mt-24 bg-tint/60 py-12 md:py-20" aria-labelledby="team-title" data-testid="team-section">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
                <Reveal className="max-w-2xl">
                    <Overline>{t.team.overline}</Overline>
                    <h2 id="team-title" className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl lg:text-5xl">
                        {t.team.title}
                    </h2>
                </Reveal>
                {hasMembers ? (
                    <div className="mt-10 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
                        {teamMembers.map((m, i) => (
                            <Reveal key={i} delay={Math.min(i * 0.06, 0.3)} className="h-full">
                                <article className="h-full overflow-hidden rounded-2xl border border-ink/10 bg-surface shadow-sm" data-testid={`team-card-${i + 1}`}>
                                    <img src={m.photo} alt={m.name[lang]} width="600" height="700" loading="lazy" className="aspect-[6/7] w-full object-cover" />
                                    <div className="p-5">
                                        <h3 className="text-base font-bold text-ink">{m.name[lang]}</h3>
                                        <p className="mt-1 text-xs font-bold uppercase tracking-[0.14em] text-gold-600">{m.role[lang]}</p>
                                        <p className="mt-2 text-sm leading-relaxed text-mist">{m.bio[lang]}</p>
                                    </div>
                                </article>
                            </Reveal>
                        ))}
                    </div>
                ) : (
                    <Reveal delay={0.1}>
                        <div
                            className="mt-10 flex flex-col items-center rounded-[2rem] border border-dashed border-ink/15 bg-surface px-8 py-14 text-center"
                            data-testid="team-pending"
                        >
                            <img src="/assets/thera-symbol-original.png" alt="" className="h-14 w-14 object-contain opacity-80" />
                            <p className="mt-5 font-display text-2xl font-semibold text-pine">{t.team.pendingTitle}</p>
                            <p className="mt-2 max-w-md text-sm leading-relaxed text-mist">{t.team.pendingText}</p>
                        </div>
                    </Reveal>
                )}
            </div>
        </section>
    );
};

export default TeamSection;
